<template>
  <div
    class="wg-row com-anm22-app-scrolling-panel"
    style="justify-content:center;height:calc(100vh - 107px);padding:10px;"
  >
    <!-- Modale per gestione rapida modifica evento -->
    <wg-spinner-modal v-if="expenseLoading"></wg-spinner-modal>
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showOutgoDialog"
      :portal="true"
      @closeModal="closeOutgoDialog"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap:nowrap;align-items:center;"
      >
        <img
          v-if="
            !isSynchronized(outgoSelected) ||
              !isOutgoImagesSynchronized(outgoSelected)
          "
          :src="$anm22.icons.getWorldIcon('offline')"
          class="com-anm22-app-img-fixed-height-m icon"
          style="margin-right:5px;"
          :title="$anm22.strLang(lang, 'Not synchronized', 'Non sincronizzato')"
        />
        <div class="com-anm22-app-text-xl" slot="header">
          {{ outgoDialogTitle }}
        </div>
      </div>
      <outgo-detail
        slot="body"
        :mode="openMode"
        :projectId="projectId"
        :userPermission="userPermission"
        :outgoRef="outgoSelected"
      ></outgo-detail>
    </wg-modal>
    <!-- 
      Modal conferma cancellazione spesa
    -->
    <wg-modal
      v-if="showDeleteDialog"
      :portal="true"
      @closeModal="closeDeleteDialog"
    >
      <div class="wg-row" style="justify-content:center;" slot="body">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "Delete expense?", "Cancellare spesa?") }}
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input
            type="button"
            class="small com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'OK', 'OK')"
            @click="deleteOutgo"
          />
          <div class="com-anm22-app-horizontal-space" style="width:20px;"></div>
          <input
            type="button"
            class="small com-anm22-button-red"
            :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
            @click="closeDeleteDialog"
          />
        </div>
      </div>
    </wg-modal>
    <div class="wg-row" style="max-width:600px;">
      <!-- Titolo e tasti di visualizzazione -->
      <div
        class="wg-row"
        style="align-items:center;justify-content:space-between;"
      >
        <div class="wg-col wg-xs-11">
          <slot></slot>
        </div>
        <div
          class="wg-col wg-xs-1 display-flex"
          style="align-items:center;justify-content:flex-end;"
        >
          <img
            v-if="windowWidth <= 992"
            :src="$anm22.icons.getWorldIcon('chat')"
            class="com-anm22-app-img-s"
            style="cursor:pointer;margin-left:5px;"
            @click="$emit('openBoard')"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <!-- Statistiche -->
      <div v-if="!loading && statsArray.length > 0" class="wg-row stats-row">
        <div class="stats-row-inner">
          <div
            v-for="(stat, curr, index) in statsArray"
            :key="'s' + index"
            class="stat-elem"
          >
            <div class="stat-total">
              {{ stat.toFixed(2) }}
              <br />
              <span style="font-size:8px;">{{
                $anm22.tableClasses.worldCurrencyType().getById(curr)[lang]
              }}</span>
            </div>
            <div class="stat-label">
              {{
                $anm22.strLang(lang, "Total ", "Totale ") +
                  $anm22.tableClasses.worldCurrencyType().getById(curr)[lang]
              }}
            </div>
          </div>
          <!-- Diaria -->
          <div v-if="diary !== 0" class="stat-elem">
            <div class="stat-total">
              {{ diary.toFixed(2) }}
              <br />
              <span style="font-size:8px;">EUR</span>
            </div>
            <div class="stat-label">
              {{ $anm22.strLang(lang, "Daily budget", "Diaria") }}
            </div>
          </div>
        </div>
      </div>
      <div class="wg-row" style="align-items:center;">
        <div class="com-anm22-app-text-xxl">
          {{ $anm22.strLang(lang, "Expenses", "Elenco spese") }}
        </div>
        <input
          v-if="canAdd"
          type="button"
          class="small"
          style="margin-left:auto;"
          :value="$anm22.strLang(lang, '+ Add expense', '+ Aggiungi spesa')"
          @click="addExpense()"
        />
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div
        v-if="loading && masters.length !== 0"
        class="wg-row"
        style="justify-content:center;"
      >
        <vue-simple-spinner size="medium" line-fg-color="rgb(136, 237, 124)" />
      </div>
      <div v-else class="wg-row">
        <div
          v-for="(outgo, index) in masters"
          :key="'o' + index"
          class="wg-row"
          style="align-items:center;"
        >
          <world-outgo
            :outgoId="outgo.idWorldOutgo"
            :mergeButton="false"
            :canEdit="canEdit(outgo)"
            :canDelete="canEdit(outgo)"
            :showDescription="true"
            @openOutgoEvent="openOutgo"
            @deleteOutgoEvent="openDeleteDialog"
          ></world-outgo>
        </div>
        <div v-if="masters.length == 0" class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, "No expenses", "Nessuna spesa") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldOutgo from "../../../../world/spa/components/WorldOutgo.vue";
import OutgoDetail from "../components/outgo/OutgoDetail.vue";
import Spinner from "vue-simple-spinner";

export default {
  props: {
    projectId: [Number, String],
    customerManager: [Boolean],
    action: String,
  },
  data() {
    return {
      loading: false,
      diary: 0,
      expenseLoading: false,
      showOutgoDialog: false,
      showDeleteDialog: false,
      outgoSelected: null,
      openMode: null,
      updateInterval: null,
      // Gestione merging delle spese
      // mergingOutgoId: 0
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
    }),
    project() {
      return this.$store.getters["projects/get"](this.projectId);
    },
    licenses() {
      return this.$store.getters["employments/getByUser"](this.user.idWorldUser)
        .filter((e) => this.project.developers.includes(e.work))
        .map((e) => this.$store.getters["licenses/getByWork"](e.work))
        .filter((l) => l);
    },
    pricing() {
      return this.$store.getters["pricings/getByProject"](this.projectId);
    },
    outgoes() {
      if (!this.loading) {
        return this.$store.getters["outgoes/getByProject"](this.projectId).sort(
          (a, b) => b.outgoDate - a.outgoDate
        );
      } else {
        return [];
      }
    },
    masters() {
      return this.outgoes.filter(
        (o) => o.masterOutgo === "" || o.masterOutgo === 0
      );
    },
    userPermission() {
      return this.$store.getters["employments/getPermByProject"](this.project);
    },
    reports() {
      return this.$store.getters["employeeExpenseReports/getAll"].filter(
        (r) =>
          this.project.users.includes(r.user) &&
          this.project.developers.includes(r.work)
      );
    },
    canAdd() {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.expenses &&
            l.config.tasks.expenses["add-rules"]
        )
        .reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.expenses["add-rules"]](this),
          true
        );
    },
    statsArray() {
      let result = {};
      if (!this.loading) {
        this.outgoes.forEach((outgo) => {
          if (!(outgo.category && outgo.category === 1)) {
            if (!(outgo.currencyType in result)) {
              result[outgo.currencyType] = 0;
            }
            result[outgo.currencyType] += outgo.amount;
          }
        });
      }
      return result;
    },
    outgoDialogTitle() {
      switch (this.openMode) {
        case "new":
          return this.$anm22.strLang(this.lang, "New expense", "Nuova spesa");
        case "view":
          return this.$anm22.strLang(
            this.lang,
            "Expense details",
            "Dettaglio spesa"
          );
        case "edit":
          return this.$anm22.strLang(
            this.lang,
            "Edit expense",
            "Modifica spesa"
          );
      }
    },
  },
  methods: {
    isSynchronized(outgo) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("WorldOutgo" + outgo.idWorldOutgo)
      );
    },
    isOutgoImagesSynchronized(outgo) {
      let isOutgoSync = true;
      outgo.images.forEach((image) => {
        if (!this.isImageSynchronized(image)) {
          isOutgoSync = false;
        }
      });
      return isOutgoSync;
    },
    isImageSynchronized(image) {
      return this.$store.getters["offline/isSynchronized"](
        this.$anm22.MD5("WorldOutgoImage" + image.syncId)
      );
    },
    searchFn(string) {
      const regexp = new RegExp(string, "i");
      let results = [];
      /* Ricerca contatti per nome */
      this.masters
        .filter((e) => {
          return -1 !== e.description.search(regexp);
        })
        .map((e) => {
          return {
            label: e.description,
            img: this.$anm22.icons.getWorldIcon("walletBlack"),
            submitFn: () => {
              this.openOutgo(e.idWorldOutgo);
            },
          };
        })
        .forEach((res) => {
          results.push(res);
        });
      return results;
    },
    canEdit(outgo) {
      return this.licenses
        .filter(
          (l) =>
            l.config.tasks &&
            l.config.tasks.expenses &&
            l.config.tasks.expenses["edit-rules"]
        )
        .reduce(
          (result, l) =>
            result &&
            this.$anm22[l.config.tasks.expenses["edit-rules"]](this, outgo),
          true
        );
    },
    addExpense() {
      this.openMode = "new";
      let outgo = {
        referencingInvite: "",
        referencingTask: "",
        referencingProject: this.projectId,
        user: this.user.idWorldUser,
        work: "",
        amount: 0,
        currencyType: this.project.currencyType || "EUR",
        taxValue: "",
        taxPercentage: "",
        tipsValue: "",
        paymentMode: 0,
        card: "",
        bankAccount: "",
        description: "",
        category: 0,
        outgoDate: this.$moment()
          .utc(this.$moment().format("YYYY-MM-DD"))
          .unix(),
        exchangeRate: "",
        exchangeValue: "",
        exchangeCurrency: "EUR",
        verificationType: 0,
        verificationDate: "",
        approvalStatus: "",
        masterOutgo: "",
        images: [],
      };
      this.openOutgoDialog(outgo);
    },
    openOutgo(outgoId) {
      this.expenseLoading = true;
      this.$http
        .get("outgo?idWorldOutgo=" + outgoId)
        .then((response) => {
          Promise.all(
            [
              "outgoes",
              "users",
              "cards",
              "cardTypes",
              "userCardAssocs",
              "employmentCardAssocs",
              "bankAccounts",
              "userBankAccountAssocs",
              "employmentBankAccountAssocs",
            ].map((d) => {
              return this.$store.dispatch(d + "/update", {
                vlf: this.$vlf(d),
                objs: response.data[d],
              });
            })
          )
            .then((result) => {
              let outgo = this.$store.getters["outgoes/get"](outgoId);
              if (this.canEdit(outgo)) {
                this.openMode = "edit";
              } else {
                this.openMode = "view";
              }
              this.expenseLoading = false;
              this.openOutgoDialog(outgo);
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          let outgo = this.$store.getters["outgoes/get"](outgoId);
          if (this.canEdit(outgo)) {
            this.openMode = "edit";
          } else {
            this.openMode = "view";
          }
          this.expenseLoading = false;
          this.openOutgoDialog(outgo);
        });
    },
    openOutgoDialog(outgo) {
      this.outgoSelected = outgo;
      this.showOutgoDialog = true;
      this.$Progress.finish();
    },
    closeOutgoDialog() {
      this.showOutgoDialog = false;
      this.outgoSelected = null;
      this.openMode = null;
    },
    openDeleteDialog(outgo) {
      this.outgoSelected = outgo;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      this.showDeleteDialog = false;
      this.outgoSelected = null;
    },
    deleteOutgo() {
      if (this.outgoSelected) {
        this.$http
          .post(
            "outgo/delete",
            {
              idWorldOutgo: this.outgoSelected.idWorldOutgo,
            },
            {
              withCredentials: true,
            }
          )
          .then((response) => {
            this.$store
              .dispatch("outgoes/delete", {
                vlf: this.$vlf("outgoes"),
                obj: this.outgoSelected,
              })
              .then((result) => {
                this.closeDeleteDialog();
              });
          })
          .catch((error) => {
            Promise.all([
              this.$store.dispatch("outgoes/delete", {
                vlf: this.$vlf("outgoes"),
                obj: this.outgoSelected,
              }),
              this.$store.dispatch("offline/saveSyncTuple", {
                _vue: this,
                _class: "WorldOutgo",
                _table: "outgoes",
                mode: "delete",
                type: "obj",
                obj: this.outgoSelected,
              }),
              // this.$anm22.saveSyncTuple(
              //   this,
              //   "WorldOutgo",
              //   "delete",
              //   this.outgoSelected
              // )
            ]).then((result) => {
              this.closeDeleteDialog();
            });
          });
      }
    },
    loadData() {
      Promise.all(
        [
          "pricings",
          "outgoes",
          "users",
          "outgoCategories",
          "outgoCategoryProjectAssocs",
          "cards",
          "cardTypes",
          "userCardAssocs",
          "employmentCardAssocs",
          "bankAccounts",
          "userBankAccountAssocs",
          "employmentBankAccountAssocs",
          "employeeExpenseReports",
        ].map((d) => {
          return this.$store.dispatch(d + "/load", this.$vlf(d));
        })
      ).then((result) => {
        this.loading = false;
        this.$Progress.finish();
        if (this.action !== "") {
          if (this.$route.query.id) {
            this[this.action](this.$route.query.id);
          } else {
            this[this.action]();
          }
        }
        this.$emit("resetAction");
      });
    },
    updateData() {
      if (!this.$store.getters["offline/isOffline"] && !document.hasFocus()) {
        this.$http
          .get("project/outgoes?idProject=" + this.project.idWorldProject)
          .then((response) => {
            if (response.data) {
              this.$store
                .dispatch("outgoes/update", {
                  vlf: this.$vlf("outgoes"),
                  objs: response.data.outgoes,
                  cleanFilters: [
                    (o) => {
                      return (
                        Number.isSafeInteger(o.idWorldOutgo) &&
                        o.referencingProject === this.project.idWorldProject
                      );
                    },
                  ],
                })
                .then(() => {
                  console.log("expenses updated");
                });
            }
          });
      }
    },
  },
  created() {
    this.loading = true;
    this.loadData();
    this.$http
      .get("project/outgoes?idProject=" + this.projectId)
      .then((response) => {
        if (response.data) {
          Promise.all(
            [
              "pricings",
              "outgoes",
              "users",
              "outgoCategories",
              "outgoCategoryProjectAssocs",
              "cards",
              "cardTypes",
              "userCardAssocs",
              "employmentCardAssocs",
              "bankAccounts",
              "userBankAccountAssocs",
              "employmentBankAccountAssocs",
              "employeeExpenseReports",
            ].map((d) => {
              if (d === "outgoes") {
                return this.$store.dispatch(d + "/update", {
                  vlf: this.$vlf(d),
                  objs: response.data[d],
                  cleanFilters: [
                    (o) => {
                      return (
                        Number.isSafeInteger(o.idWorldOutgo) &&
                        o.referencingProject === this.project.idWorldProject
                      );
                    },
                  ],
                });
              } else if (
                d === "employmentCardAssocs" ||
                d === "employmentBankAccountAssocs"
              ) {
                const userIds = this.project.users;
                return this.$store.dispatch(d + "/update", {
                  vlf: this.$vlf(d),
                  objs: response.data[d],
                  cleanFilters: [
                    (assoc) => {
                      return userIds.includes(assoc.user);
                    },
                  ],
                });
              } else {
                return this.$store.dispatch(d + "/update", {
                  vlf: this.$vlf(d),
                  objs: response.data[d],
                });
              }
            })
          )
            .then((result) => {
              this.diary = response.data.diary;
              this.$store.dispatch("offline/sync", {
                _vue: this,
                blocking: true,
                callback: async (data) => {
                  const update = data.success.find(
                    (d) =>
                      d.requestData.obj.idWorldProject === this.$route.params.id
                  );
                  if (update) {
                    this.$router.replace(
                      "/project/" + update.responseData.idWorldProject
                    );
                  }
                },
              });
            })
            .catch((error) => console.log(error));
        }
      })
      .catch((error) => console.log(error));
  },
  mounted() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", {
      hintFn: this.searchFn,
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        this.updateData();
      }, 30000);
    });
  },
  destroyed() {
    this.$anm22.eventBus.$emit("world-headbar-search-config", null);
    clearInterval(this.updateInterval);
  },
  components: {
    WorldOutgo,
    OutgoDetail,
    "vue-simple-spinner": Spinner,
  },
};
</script>

<style lang="scss" scoped>
.stats-row {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin-bottom: 10px;
  height: 108px;
}
.stats-row-inner {
  white-space: nowrap;
  margin-bottom: 10px;
  height: 98px;
}
.stat-elem {
  display: inline-block;
  max-width: 150px;
  margin: 0 10px 10px 10px;
}
.stat-total {
  font-size: 14px;
  width: 70px;
  height: 70px;
  box-sizing: border-box;
  border: 3px solid #ccc;
  border-radius: 50px;
  text-align: center;
  padding-top: 20px;
  line-height: 1.1;
}
.stat-label {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  margin-top: 2px;
}
</style>
